/**
 * The rarity tiers a storefront can recolor, with the opener's rail palette as
 * the fallback. One entry per value `getItemRarity` produces, so every tier here
 * is one a shopper can actually be shown; the defaults mirror the matching keys
 * of DEFAULT_RARITY_RAIL_HEX in @loot-os/react.
 *
 * Their own module rather than part of index.ts so `rarityColor.ts` can read
 * them without importing index back and forming a cycle.
 */
export const STOREFRONT_RARITY_TIERS = [
  { key: "0", label: "Common", default: "#A9A9CA" },
  { key: "1", label: "Uncommon", default: "#22C55E" },
  { key: "2", label: "Rare", default: "#3B82F6" },
  { key: "3", label: "Epic", default: "#A855F7" },
  { key: "4", label: "Legendary", default: "#FFC700" },
] as const;

export type StorefrontRarityKey = (typeof STOREFRONT_RARITY_TIERS)[number]["key"];

export const STOREFRONT_RARITY_KEYS = STOREFRONT_RARITY_TIERS.map(
  (tier) => tier.key,
) as StorefrontRarityKey[];
